<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-select
          v-model="providerIdLocale"
          dense
          outlined
          label="Provider Id"
          item-text="nome"
          item-value="id"
          validate-on-blur
          :loading="loading"
          :items="provedoresWhatsAppIds"
          :rules="[validators.select]"
          @change="v => $emit('update:providerId', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="providerAPITokenLocale"
          dense
          outlined
          label="Provider API Token"
          hint="Máximo de 800 caracteres"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 800) || 'Máximo de 800 caracteres']"
          @change="v => $emit('update:providerAPIToken', v)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="providerIdentifierLocale"
          dense
          outlined
          label="Provider Identifier"
          hint="Máximo de 300 caracteres"
          validate-on-blur
          :loading="loading"
          :rules="[validators.required, v => (!!v && v.length <= 300) || 'Máximo de 300 caracteres']"
          @change="v => $emit('update:providerIdentifier', v)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import CanalWhatsAppProviderEnum from '@/models/entities/canal/CanalWhatsAppProviderEnum'

export default {
  emits: ['update:providerId', 'update:providerAPIToken', 'update:providerIdentifier'],

  props: {
    canalData: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const providerAPITokenLocale = ref(null)
    const providerIdentifierLocale = ref(null)
    const providerIdLocale = ref(null)

    const provedoresWhatsAppIds = [CanalWhatsAppProviderEnum.Zenvia]

    watch(
      () => props.canalData,
      value => {
        providerAPITokenLocale.value = value?.providerAPIToken || null
        providerIdentifierLocale.value = value?.providerIdentifier || null
        providerIdLocale.value = value?.providerId || null
      },
      { immediate: true },
    )

    return {
      providerAPITokenLocale,
      providerIdentifierLocale,
      providerIdLocale,
      provedoresWhatsAppIds,
      validators: {
        required,
        select,
      },
    }
  },
}
</script>
